"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PURCHASE_SWEEP_SETTLED_AMOUNT_DELTA_RATIO_THRESHOLD = exports.AvenPurchaseTxnSweepStatus = void 0;
var AvenPurchaseTxnSweepStatus;
(function (AvenPurchaseTxnSweepStatus) {
    AvenPurchaseTxnSweepStatus["initiated"] = "initiated";
    AvenPurchaseTxnSweepStatus["offered"] = "offered";
    AvenPurchaseTxnSweepStatus["accepted"] = "accepted";
    AvenPurchaseTxnSweepStatus["completed"] = "completed";
    AvenPurchaseTxnSweepStatus["canceledDueToSettledAmount"] = "canceledDueToSettledAmount";
    AvenPurchaseTxnSweepStatus["canceledDueToNotEnoughPrincipal"] = "canceledDueToNotEnoughPrincipal";
})(AvenPurchaseTxnSweepStatus || (exports.AvenPurchaseTxnSweepStatus = AvenPurchaseTxnSweepStatus = {}));
// The settled amount cannot differ from the original authorized amount by more than this ratio threshold. If it does, the purchase sweep will be canceled (set to 'canceledDueToSettledAmount' status).
// As of 10/02/2025, we set the threshold to be 0, meaning the settled amount needs to be exactly the same as the original authorized amount.
// See https://docs.google.com/document/d/1fKf_Nmv08XYP_PTu0NRAyCZXHVxB9lY_P0ygQgvzlAc/edit?tab=t.0
exports.PURCHASE_SWEEP_SETTLED_AMOUNT_DELTA_RATIO_THRESHOLD = 0;
